/// <amd-module name="Widgets/QueryScalarWidget/QueryScalarCacheableQuery" />
import { ICacheableQuery } from "Reporting/Common/ICacheableQuery";
import { IVssPageContext } from "VSS/Platform/Context";
import { QueryScalarWidgetRestClient } from "Widgets/QueryScalarWidget/QueryScalarWidgetRestClient";
import * as Resources from "Widgets/QueryScalarWidget/Resources";

export class QueryScalarCacheableQuery implements ICacheableQuery<number> {
    constructor(private queryId: string, private projectId: string, private teamId: string) {}

    public async runQuery(pageContext: IVssPageContext): Promise<number> {
        const client = pageContext.getRestClient<QueryScalarWidgetRestClient>("QueryScalarWidgetRestClient");
        try {
            return await client.getQueryResultCount(this.queryId, this.projectId, this.teamId);
        } catch (error) {
            switch (error.status) {
                case 400:
                    throw [error.message, Resources.QueryApi400].join(" ");
                case 404:
                    throw [error.message, Resources.QueryApi404].join(" ");
                case 408:
                    throw [error.message, Resources.QueryApi408].join(" ");
                case 500:
                    throw [error.message, Resources.QueryApi50x].join(" ");
                case 503:
                    throw [error.message, Resources.QueryApi50x].join(" ");
                default:
                    throw error;
            }
        }
    }

    public getKey(): string {
        return JSON.stringify({
            queryId: this.queryId
        });
    }
}
